import { ChronoUnit } from 'js-joda';
import { TimeValue } from '@lifetools/shared-utils-time';
import { getTimes } from './getTimes';
import { normalizeTime } from './normalizeTime';
import { TimeSlot } from '../../types/TimeSlot';
import { ScheduleTime } from '../../types/ScheduleTime';

const minutesInDay = 24 * 60;

export function calculateTimeSlots(
  startTime: TimeValue | ScheduleTime,
  endTime: TimeValue | ScheduleTime,
  interval: number,
): TimeSlot[] {
  // HACK: See note in `normalizeTime` why this may no longer be needed. [twl 22.Jun.23]
  startTime = normalizeTime(startTime);
  endTime = normalizeTime(endTime);

  // A non-positive interval would make `getTimes` loop forever (the offset never
  // advances), so guard against corrupted/missing interval data before iterating.
  if (!(interval > 0)) {
    console.error(
      `calculateTimeSlots: invalid interval ${interval}; expected a positive number. ` +
      `Returning no time slots to avoid an infinite loop.`
    );
    return [];
  }

  // The (x + minutesInDay) % minutesInDay handles when the endTime is after midnight
  const length = startTime.equals(endTime) ? minutesInDay :
                   (startTime.until(endTime, ChronoUnit.MINUTES) + minutesInDay) % minutesInDay;

  return getTimes(startTime, interval, length);
}
